import { render, staticRenderFns } from "./DialogShopee.vue?vue&type=template&id=59f0cb22"
import script from "./DialogShopee.vue?vue&type=script&lang=js"
export * from "./DialogShopee.vue?vue&type=script&lang=js"
import style0 from "./DialogShopee.vue?vue&type=style&index=0&id=59f0cb22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports